module.exports = __webpack_public_path__ + "static/img/left.7280988.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 1